import { useRequiredData } from "#app/(required)/useRequiredData";
import { getCurrentJwt } from "#app/(unauthorized)/authentication/jwt";
import { Segment } from "#app/(unauthorized)/authentication/segment";
import { filterNavRoutesConfig } from "#app/lib/route-filters/filterNav";
import { useFeatureToggles } from "#app/lib/useFeatureToggles";
import { parseRoutesConfig, type NavRoutes } from "#ui/nav.utils";

import { NAV_ROUTES_CONFIG } from "./nav-routes-config";

export function useNavRoutes() {
  const jwt = getCurrentJwt();
  const { requiredData } = useRequiredData();

  const { data: featureToggles } = useFeatureToggles();

  const isBillPayEnabled =
    featureToggles?.["BillPayLoginsFeature"]?.isEnabled ?? false;

  const isUnauthenticated = jwt.segment == Segment.NotLoggedIn;

  let routes: NavRoutes = [];
  if (!isUnauthenticated) {
    const navRoutesConfigFiltered = filterNavRoutesConfig({
      jwt,
      navRoutesConfig: NAV_ROUTES_CONFIG,
      requiredData: requiredData ?? {
        hasBairdResearch: false,
        canUseFinancialPlanning: false,
        hasVisiblePlans: false,
        hasApl: false,
        canUseTrust: false,
        heldawayUserEligibility: false,
        heldawayUserEnrolled: false,
        hasStartedOnboarding: false,
      },
    });
    routes = parseRoutesConfig(navRoutesConfigFiltered);
  }

  if (isBillPayEnabled) {
    const accountServicesRoute = routes.find((r) => r.id === "AccountServices");
    if (accountServicesRoute && "paths" in accountServicesRoute) {
      const ebillPath = accountServicesRoute.paths?.find(
        (p) => p.id === "AccountServicesEbill",
      );
      if (ebillPath) {
        ebillPath.element = "Bill Pay";
      }
    }
  }

  // TODO: refactor nav route extractions
  const routesPrimary = routes.filter(
    (r) =>
      ![
        "ProfileAndSettings",
        "MyTeam",
        "SignIn",
        "SignOut",
        "RegisterClient",
        "RegisterProspect",
      ].includes(r.id),
  );
  return {
    mobileOnly: routesPrimary,
    desktopOnly: routesPrimary,
    Home: routes.find((r) =>
      ["Home", "BairdResearchCorporate"].includes(r.id),
    )!,
    DocumentsReceived: routes
      .find((r) => r.id === "Documents")
      ?.paths?.find((r) => r.id === "DocumentsReceived"),
    ProfileAndSettings: routes.find((r) => r.id === "ProfileAndSettings")!,
    MyTeam: routes.find((r) => r.id === "MyTeam")!,
    SignOut: NAV_ROUTES_CONFIG.SignOut, // SignOut is not filtered
    All: routes,
  };
}
